import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  General: {
    eventType: '5x5',
    topTimerWhenFoulCalled: true,
    whenToResetFoul: 'Quarter',
    possessionArrow: 'Shot Clock',
    shotClockOptions: {
      shotClockCheck: true,
      shotClockViolation: true,
      foul: true,
      timeout: true,
      outOfBounds: true,
      goalWithinLast2Minutes: true,
      goalAnytimeDuringOvertime: true,
    },
    fiveXFive: {
      totalMainPlayersAre: '5',
      periodSystem: {
        Q1_Q4: false,
        Quarters4: false,
      },
      defaultTimerPerPeriod: '10',
      defaultTimerPerOvertime: '10',
    },
    threeXThree: {
      totalMainPlayersAre: '3',
      periodSystem: {
        single: 'single',
      },
      disabledOption: {
        Made3PT: '3PT Made',
        Miss3PT: '3PT Miss',
      },
      defaultTimerPerPeriod: '10',
      defaultTimerPerOvertime: '10',
    },
  },
  ScoringDialogs: {
    staticMode: false,
    responsiveMode: true,
    staticData: {
      assistAfterFGMade: false,
      reboundAfterFGMissed: false,
      turnoverAfterSteal: false,
      receiveAPersonalFoul: false,
    },
    responsiveData: {
      assistAfterFGMade: true,
      reboundAfterFGMissed: true,
      turnoverAfterSteal: true,
      receiveAPersonalFoul: true,
    },
    showShotChart: !true,
    selectionAfterFieldGoalAttempt: !true,
  },
  minutes: 10,
  seconds: 0,
  isRunning: false,
  selectEvent: [],
  newMinutes: 0,
  newSeconds: 0,
  newIsRunning: false,
  eventOptions: [],
};

const settingSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    fiveXFiveMode(state, action) {
      const { threeXThree, ...restOfAll } = state.General;
      state.General = {
        ...restOfAll,
        ...action.payload,
      };
    },
    threeXThreeMode(state, action) {
      const { fiveXFive, ...restOfGeneral } = state.General;
      state.General = {
        ...restOfGeneral,
        ...action.payload,
      };
    },
    topTimerWhenFoulCalled(state, action) {
      state.General.topTimerWhenFoulCalled = action.payload;
    },
    whenToResetFoul(state, action) {
      state.General.whenToResetFoul = action.payload;
    },
    fiveXFiveDefaultPeriod(state, action) {
      state.minutes = action.payload;
      state.General.fiveXFive.defaultTimerPerPeriod = action.payload;
    },
    fiveXFiveOvertimePeriod(state, action) {
      state.General.fiveXFive.defaultTimerPerOvertime = action.payload;
    },
    threeXThreeDefaultPeriod(state, action) {
      state.minutes = action.payload;
      state.General.threeXThree.defaultTimerPerPeriod = action.payload;
    },
    threeXThreeOvertimePeriod(state, action) {
      state.General.threeXThree.defaultTimerPerOvertime = action.payload;
    },
    periodSystemQ1Q4(state, action) {
      state.General.fiveXFive.periodSystem.Q1_Q4 = action.payload;
    },
    periodSystemQ4(state, action) {
      state.General.fiveXFive.periodSystem.Quarters4 = action.payload;
    },
    staticModeOn(state) {
      state.ScoringDialogs.staticMode = true;
      state.ScoringDialogs.responsiveMode = false;
    },
    responsiveModeOn(state) {
      state.ScoringDialogs.staticMode = false;
      state.ScoringDialogs.responsiveMode = true;
    },
    selectionAfterFieldGoalAttempt(state, action) {
      state.ScoringDialogs.selectionAfterFieldGoalAttempt = action.payload;
    },
    showShotChart(state, action) {
      state.ScoringDialogs.showShotChart = action.payload;
    },
    setQuarter(state, action) {
      state.quarter = action.payload;
    },
    setMinutes(state, action) {
      const minutes = parseInt(action.payload);
      if (Number.isInteger(minutes) && minutes >= 0) {
        state.minutes = minutes;
      }
    },
    setSeconds(state, action) {
      const seconds = parseInt(action.payload);
      if (Number.isInteger(seconds) && seconds >= 0) {
        state.seconds = seconds;
      }
    },
    setIsRunning(state, action) {
      state.isRunning = action.payload;
    },
    resetTimer(state) {
      state.minutes = 0;
    },
    selectEvent(state, action) {
      state.selectEvent = [...action.payload];
    },
    setNewMinutes(state, action) {
      state.newMinutes = action.payload;
    },
    setNewSeconds(state, action) {
      state.newSeconds = action.payload;
    },
    setNewIsRunning(state, action) {
      state.newIsRunning = action.payload;
    },
    resetNewTimer(state) {
      state.newMinutes = 0;
      state.newSeconds = 0;
      state.newIsRunning = false;
    },
    setEventOptions(state, action) {
      state.eventOptions = action.payload && action.payload.length > 0 ? action.payload.map(event => ({
        value: `${event.event_code} GC${event?.event_group_id} ${event.team_a_name ? event.team_a_name : 'No Team Name'} vs ${event.team_b_name ? event.team_b_name : 'No Team Name'}`,
        label: `${event.event_code} GC${event?.event_group_id} ${event.team_a_name ? event.team_a_name : 'No Team Name'} vs ${event.team_b_name ? event.team_b_name : 'No Team Name'}`
      })) : [];
    },
    toggleShotClockOption(state, action) {
      const { General } = state;
      const { shotClockOptions, ...restOfGeneral } = General;

      if (action.payload == 'shotClockCheck') {

        const newValue = !Object.values(shotClockOptions).every(value => value);
        state.General = {
          ...restOfGeneral,
          shotClockOptions: Object.keys(shotClockOptions).reduce((acc, key) => {
            acc[key] = newValue;
            return acc;
          }, {}),
        };
      } else {
        state.General = {
          ...restOfGeneral,
          shotClockOptions: {
            ...shotClockOptions,
            [action.payload]: !shotClockOptions[action.payload], // Toggle the specific option
          },
        };
      }
    },
    possessionArrow(state, action) {
      state.General.possessionArrow = action.payload;
    },
    toggleShotClockCheck(state, action) {
      const { General } = state;
      const { shotClockOptions, ...restOfGeneral } = General;
      state.General = {
        ...restOfGeneral,
        shotClockOptions: {
          ...shotClockOptions,
          shotClockCheck: action.payload,
        },
      };
    },
    toggleShotClockViolation(state, action) {
      const { General } = state;
      const { shotClockOptions, ...restOfGeneral } = General;
      state.General = {
        ...restOfGeneral,
        shotClockOptions: {
          ...shotClockOptions,
          shotClockViolation: action.payload,
        },
      };
    },
    toggleFoul(state, action) {
      const { General } = state;
      const { shotClockOptions, ...restOfGeneral } = General;
      state.General = {
        ...restOfGeneral,
        shotClockOptions: {
          ...shotClockOptions,
          foul: action.payload,
        },
      };
    },
    toggleTimeout(state, action) {
      const { General } = state;
      const { shotClockOptions, ...restOfGeneral } = General;
      state.General = {
        ...restOfGeneral,
        shotClockOptions: {
          ...shotClockOptions,
          timeout: action.payload,
        },
      };
    },
    toggleOutOfBounds(state, action) {
      const { General } = state;
      const { shotClockOptions, ...restOfGeneral } = General;
      state.General = {
        ...restOfGeneral,
        shotClockOptions: {
          ...shotClockOptions,
          outOfBounds: action.payload,
        },
      };
    },
    toggleGoalWithinLast2Minutes(state, action) {
      const { General } = state;
      const { shotClockOptions, ...restOfGeneral } = General;
      state.General = {
        ...restOfGeneral,
        shotClockOptions: {
          ...shotClockOptions,
          goalWithinLast2Minutes: action.payload,
        },
      };
    },
    toggleGoalAnytimeDuringOvertime(state, action) {
      const { General } = state;
      const { shotClockOptions, ...restOfGeneral } = General;
      state.General = {
        ...restOfGeneral,
        shotClockOptions: {
          ...shotClockOptions,
          goalAnytimeDuringOvertime: action.payload,
        },
      };
    },
  },
});

export const {
  fiveXFiveMode,
  threeXThreeMode,
  topTimerWhenFoulCalled,
  whenToResetFoul,
  fiveXFiveDefaultPeriod,
  fiveXFiveOvertimePeriod,
  threeXThreeDefaultPeriod,
  threeXThreeOvertimePeriod,
  periodSystemQ1Q4,
  periodSystemQ4,
  staticModeOn,
  responsiveModeOn,
  selectionAfterFieldGoalAttempt,
  showShotChart,
  setQuarter,
  setMinutes,
  setSeconds,
  setIsRunning,
  resetTimer,
  selectEvent,
  setNewMinutes,
  setNewSeconds,
  setNewIsRunning,
  resetNewTimer,
  setEventOptions,
  toggleShotClockOption,
  possessionArrow,
  toggleShotClockCheck,
  toggleShotClockViolation,
  toggleFoul,
  toggleTimeout,
  toggleOutOfBounds,
  toggleGoalWithinLast2Minutes,
  toggleGoalAnytimeDuringOvertime
} = settingSlice.actions;

export default settingSlice.reducer;
